import React, { useState, useEffect } from "react";
import { RiNotification2Line } from "react-icons/ri";
import classes from "../Header.module.scss";
import PersianPrice from "../PersianPrice";
import Tooltip from "@material-ui/core/Tooltip";
import { useTranslation } from "react-i18next";
import { setPageTitle } from "../../../actions";
import { useDispatch } from "react-redux";
import MessageDropDown from "./messageDropDown";
import { getAxios } from "api/Axios";
import { notificationListApi, notificationApi } from "api/Urls";
import { userSignOut } from "actions";
import { useSnackbar } from "notistack";

const Message = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const userUuid = localStorage.getItem("uuid");
  const [anchorEl, setAnchorEl] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [unSeenMessage, setUnSeenMessage] = useState(0);

  useEffect(() => {
    setLoading(true);
    requestList();
  }, []);

  useEffect(() => {
    countUnseenMessages(data);
  }, [data]);

  /**
   * Handle notifications request and set in data state.
   * @author Mohammad Khalili
   */
  const requestList = () => {
    getAxios(notificationListApi)
      .then((d) => {
        setData(
          d?.data?.notification.sort(function (a, b) {
            return new Date(b.created_at) - new Date(a.created_at);
          })
        );
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err?.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        } else {
          console.log(err);
        }
        if (err?.response?.status === 401) {
          dispatch(userSignOut());
        }
      });
  };

  /**
   * Reset data state value after user seen one message.
   * @author Mohammad Khalili
   * @param {string} id
   */
  const getNotificationSeen = (id) => {
    setData(
      data.map((d) => {
        if (d.uuid === id) {
          return { ...d, seen_by: [...d.seen_by, userUuid] };
        } else {
          return d;
        }
      })
    );
    getAxios(`${notificationApi}${id}`)
      .then((res) => {
        if (res.status === 200) {
          console.log(res);
        }
      })
      .catch((err) => {
        if (err?.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        } else {
          console.log(err);
        }
      });
  };

  /**
   * Count Unseen messages for show on header.
   * @author Mohammad Khalili
   * @param {array} notifications
   */
  const countUnseenMessages = (notifications) => {
    if (userUuid) {
      setUnSeenMessage(
        notifications.filter((notification) => {
          return notification.seen_by.indexOf(userUuid) === -1;
        })
      );
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleRequestClose = () => {
    setAnchorEl(null);
    requestList();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <Tooltip
        aria-describedby={id}
        title={t("header.messages")}
        arrow
        placement="bottom"
      >
        <div
          onClick={handleClick}
          style={{ marginRight: "10px" }}
          className={classes.showHeader}
        >
          <div className={classes.headerButton}>
            <span
              onClick={() =>
                dispatch(setPageTitle(t("notifications.page_title")))
              }
              style={{ display: "flex", marginRight: 5, marginLeft: 5 }}
            >
              <span
                className={classes.profileTitle}
                style={{
                  marginRight: 10,
                  fontWeight: "bold",
                  fontSize: 15,
                }}
              >
                {i18n.language === "fa" ? (
                  <PersianPrice number={unSeenMessage.length} />
                ) : (
                  unSeenMessage.length
                )}
              </span>
              <RiNotification2Line
                fontSize={"large"}
                style={{ marginRight: 10 }}
                className={classes.icons}
              />
            </span>
          </div>
        </div>
      </Tooltip>
      <MessageDropDown
        open={open}
        data={data}
        loading={loading}
        userUuid={userUuid}
        id={id}
        anchorEl={anchorEl}
        handleRequestClose={handleRequestClose}
        getNotificationSeen={getNotificationSeen}
      />
    </>
  );
};

export default Message;
